<template>
  <div class="little-academy__filters gap-8px">
    <b-dropdown ref="skillDropdown" multiple custom aria-role="list" class="filter-skills-dropdown">
      <template #trigger>
        <BaseButton rounded variant="outlined" buttonClass="border-gray-6 fill-gray-6 text-gray-6 font-600" :size="40">
          <IconSVG
            name="filter"
            :width="24"
            :height="24"
            :color="seletedTags.length > 0 ? '#00b8ec' : '#999'"
            :iconStyle="{ marginRight: '10px' }"
          ></IconSVG
          >{{ $t('filter') }}
        </BaseButton>
      </template>
      <div class="filter-skills-dropdown__options">
        <p class="has-text-primary">{{ $t('skills') }}</p>
        <br />
        <div>
          <span
            v-for="(skill, index) in filterSkills"
            :key="skill.id"
            outlined
            :class="getClassButtonSkill(skill)"
            @click="handleSelectSkill(skill, index)"
            >{{ translationFilterItemName(skill.name) }}</span
          >
        </div>
        <hr />
        <footer class="flex gap-8px flex-end">
          <BaseButton variant="outlined" :size="40" @click="handleClearFilter">
            {{ $t('clear-all-filters') }}
          </BaseButton>
          <BaseButton variant="outlined" :size="40" @click="closeDropdown">{{ $t('cancel') }}</BaseButton>
          <BaseButton variant="filled" :size="40" @click="handleApplyFilter">{{ $t('apply-filters') }}</BaseButton>
        </footer>
      </div>
    </b-dropdown>
    <BaseSearch inputClass="w-128px" :size="40" :value="searchText" :onChange="handleChangeSearch" />
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'
import cn from 'classnames'
import omit from 'lodash/omit'
import IconSVG from '~/components/common/IconSVG'
import BaseButton from '~/components/v2/Inputs/BaseButton.vue'
import BaseSearch from '~/components/v2/Inputs/BaseSearch.vue'
import { COURSE_LIMIT } from '~/utils/const.js'

export default {
  components: {
    IconSVG,
    BaseButton,
    BaseSearch,
  },
  data() {
    return {
      searchText: '',
      latestSearch: '',
      filterSkills: [],
      dropdownInstance: null,
    }
  },
  computed: {
    ...mapGetters({
      skills: 'topic/tags',
      filterCourses: 'home/filterCourses',
    }),
    seletedTags() {
      return this.filterSkills.filter((skill) => skill.selected).map((skill) => skill.name)
    },
  },
  methods: {
    ...mapActions({
      searchAcademyCourses: 'home/FETCH_ACADEMY_COURSES',
    }),
    ...mapMutations({
      setFilterCourses: 'home/SET_FILTER_COURSE',
      SET_FETCHING: 'home/SET_FETCHING',
    }),
    replaceRouter(params, isClearing = false) {
      const queryParams = {
        ...this.$route.query,
        ...params,
      }
      this.$router.replace({
        query: isClearing ? omit(queryParams, [Object.keys(params)[0]]) : queryParams,
      })
    },
    handleChangeSearch(value) {
      this.searchText = value
      this.searchCourses()
    },
    async searchCourses() {
      if (this.latestSearch === this.searchText) {
        return
      }
      this.setFilterCourses({ ...this.filterCourses, search: this.searchText })
      this.SET_FETCHING(true)
      await this.searchAcademyCourses({ isRenew: true, includeSharedCourseMode: 'NONE' })
      await this.searchAcademyCourses({
        isRenew: true,
        type: 'INTERNAL',
        status: 'ACTIVATED',
        isLatest: true,
        onlyShowEnrolledVersion: true,
        sharedCourseEnrollable: true,
        includeSharedCourseMode: 'ALL',
      })
      this.SET_FETCHING(false)
      this.latestSearch = this.searchText
      this.replaceRouter({ search: this.searchText }, this.searchText === '')
    },
    handleSelectSkill(skill, index) {
      this.$set(this.filterSkills, index, {
        ...skill,
        selected: !skill.selected,
      })
    },
    async handleClearFilter() {
      this.filterSkills = this.filterSkills.map((skill) => {
        return {
          ...skill,
          selected: false,
        }
      })
      this.setFilterCourses({ ...this.filterCourses, tags: [] })
      this.SET_FETCHING(true)
      await this.searchAcademyCourses({ isRenew: true })
      this.SET_FETCHING(false)
      this.replaceRouter({ tags: [] }, true)
      this.closeDropdown()
    },
    handleApplyFilter() {
      this.setFilterCourses({ ...this.filterCourses, tags: this.seletedTags })
      this.searchAcademyCourses({ isRenew: true })
      this.replaceRouter({ tags: this.seletedTags.join('-') })
      this.closeDropdown()
    },
    getClassButtonSkill(skill) {
      const selectedClass = skill.selected ? 'is-selected' : ''
      return cn('has-font-weight-600 btn-skill', selectedClass)
    },
    closeDropdown() {
      if (this.dropdownInstance) {
        this.dropdownInstance.isActive = false
      }
    },
    translationFilterItemName(name) {
      if (name === 'Health, Safety and Nutrition') {
        return this.$t('health-safety-and-nutrition')
      }
      return name ? this.$t(`${name.split(' ').join('-').toLowerCase()}`) : ''
    },
    initFilterCourses() {
      const { search, tags } = this.$route.query
      const formatedTags = tags ? tags.split('-') : []
      this.setFilterCourses({ search, tags: formatedTags, limit: COURSE_LIMIT })
      this.filterSkills = this.filterSkills.map((skill) => ({
        ...skill,
        selected: formatedTags.includes(skill.name),
      }))
      this.searchText = this.latestSearch = search || ''
    },
  },
  created() {
    this.filterSkills = this.skills.map((s) => ({ ...s, selected: false }))
    this.initFilterCourses()
  },
  mounted() {
    this.$nextTick(() => {
      if (this.$refs.skillDropdown) {
        this.dropdownInstance = this.$refs.skillDropdown
      }
    })
  },
}
</script>
<style lang="scss" scoped>
::v-deep.little-academy__filters {
  display: flex;
  align-items: center;
  right: 300px;

  .filter-search-input {
    width: 240px;

    .input {
      height: 40px;
      border-color: #999;
      color: #999;

      &:focus {
        box-shadow: unset;
      }
    }

    .icon {
      color: #999;
    }
  }

  .btn-skill {
    font-size: 18px;
    margin-right: 10px;
    margin-bottom: 15px;
    color: $color-soft-grey;
    border: 1px solid $color-regular-grey;
    height: 40px;
    min-width: 200px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    padding: 5px 10px;
    border-radius: 5px;
    cursor: pointer;

    &.is-selected {
      color: $color-bright-sky-blue-two;
      border-color: $color-bright-sky-blue-two;
      background-color: rgba(229, 247, 253, 0.5);
    }
  }

  .filter-skills-dropdown {
    .is-filtered {
      color: $color-bright-sky-blue-two;
      border-color: $color-bright-sky-blue-two;
    }

    .dropdown-menu {
      width: 815px;
      left: -429px;
      top: 50px;
      padding-top: 0;
      border-radius: 8px;
      border-top: 0;
      background-color: $color-lighter-grey;

      @media screen and (max-width: 540px) {
        max-width: 300px;

        .btn-skill {
          font-size: 14px;
          margin-right: 0;
          min-height: 32px;
          height: auto;
          min-width: unset;
          padding: 5px 10px;
        }
      }
    }

    .dropdown-content {
      box-shadow: none;
      border: solid 1px $color-grey-3;
      padding: 20px;
      background-color: $color-lighter-grey;
    }

    hr {
      background-color: $color-grey-3;
    }

    .is-flex {
      justify-content: flex-end;
    }

    .footer-btn {
      color: $color-soft-grey;
      margin-right: 10px;
    }

    @media screen and (max-width: 1023px) {
      hr {
        margin: 0.5rem 0;
      }

      .is-flex {
        justify-content: space-around;
      }

      .footer-btn,
      .is-primary {
        min-height: 36px;
        height: 36px;
        font-size: 16px;
        width: auto;
        min-width: unset;
        margin-top: 12px;
      }
    }

    @media screen and (max-width: 540px) {
      .footer-btn,
      .is-primary {
        min-height: 32px;
        height: 32px;
        font-size: 14px;
        width: auto;
        min-width: unset;
        margin-top: 12px;
      }
    }
  }
}
</style>
